(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/common/http'), require('@angular/core'), require('@angular/router'), require('rxjs/add/observable/fromEvent'), require('rxjs/add/observable/interval'), require('rxjs/add/observable/throw'), require('rxjs/add/operator/catch'), require('rxjs/add/operator/do'), require('rxjs/add/operator/filter'), require('rxjs/add/operator/pluck'), require('rxjs/add/operator/share')) :
	typeof define === 'function' && define.amd ? define(['exports', '@angular/common/http', '@angular/core', '@angular/router', 'rxjs/add/observable/fromEvent', 'rxjs/add/observable/interval', 'rxjs/add/observable/throw', 'rxjs/add/operator/catch', 'rxjs/add/operator/do', 'rxjs/add/operator/filter', 'rxjs/add/operator/pluck', 'rxjs/add/operator/share'], factory) :
	(factory((global.auth = {}),global.http,global.core,global.router));
}(this, (function (exports,http,core,router) { 'use strict';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AuthUtilsService = (function () {
    function AuthUtilsService() {
    }
    // Try to get auth data from storage.
    /**
     * @return {?}
     */
    AuthUtilsService.prototype.getAuthDataFromStorage = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ authData = {
            accessToken: localStorage.getItem('accessToken'),
            client: localStorage.getItem('client'),
            expiry: localStorage.getItem('expiry'),
            tokenType: localStorage.getItem('tokenType'),
            uid: localStorage.getItem('uid')
        };
        if (this.checkAuthData(authData)) {
            this.atCurrentAuthData = authData;
        }
        return authData;
    };
    // Check if auth data complete and if response token is newer
    /**
     * @param {?} authData
     * @return {?}
     */
    AuthUtilsService.prototype.checkAuthData = /**
     * @param {?} authData
     * @return {?}
     */
    function (authData) {
        if (authData.accessToken != null &&
            authData.client != null &&
            authData.expiry != null &&
            authData.tokenType != null &&
            authData.uid != null) {
            if (this.atCurrentAuthData != null) {
                return authData.expiry >= this.atCurrentAuthData.expiry;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    };
    AuthUtilsService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    AuthUtilsService.ctorParameters = function () { return []; };
    return AuthUtilsService;
}());

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AuthService = (function (_super) {
    __extends(AuthService, _super);
    function AuthService(http$$1, activatedRoute, router$$1) {
        var _this = _super.call(this) || this;
        _this.http = http$$1;
        _this.activatedRoute = activatedRoute;
        _this.router = router$$1;
        _this.atAsyncStatus = new core.EventEmitter();
        return _this;
    }
    Object.defineProperty(AuthService.prototype, "currentUserType", {
        get: /**
         * @return {?}
         */
        function () {
            if (this.atCurrentUserType != null) {
                return this.atCurrentUserType.name;
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "currentUserData", {
        get: /**
         * @return {?}
         */
        function () {
            return this.atCurrentUserData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "currentAuthData", {
        get: /**
         * @return {?}
         */
        function () {
            return this.atCurrentAuthData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "currentAuthHeaders", {
        get: /**
         * @return {?}
         */
        function () {
            if (this.atCurrentAuthData != null) {
                return new Headers({
                    'access-token': this.atCurrentAuthData.accessToken,
                    'client': this.atCurrentAuthData.client,
                    'expiry': this.atCurrentAuthData.expiry,
                    'token-type': this.atCurrentAuthData.tokenType,
                    'uid': this.atCurrentAuthData.uid
                });
            }
            return new Headers;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AuthService.prototype.userSignedIn = /**
     * @return {?}
     */
    function () {
        return !!this.atCurrentAuthData;
    };
    /**
     * @param {?} url
     * @return {?}
     */
    AuthService.prototype.hasAuthParams = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return url.includes('uid');
    };
    /**
     * @param {?} url
     * @param {?} name
     * @return {?}
     */
    AuthService.prototype.getUrlParameter = /**
     * @param {?} url
     * @param {?} name
     * @return {?}
     */
    function (url, name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var /** @type {?} */ regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var /** @type {?} */ results = regex.exec(url);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    /**
     * @param {?=} state
     * @return {?}
     */
    AuthService.prototype.canActivateAsync = /**
     * @param {?=} state
     * @return {?}
     */
    function (state) {
        var _this = this;
        var /** @type {?} */ authData;
        // provide fallback for IE 11. See https://developer.microsoft.com/en-us/microsoft-edge/platform/status/urlapi/
        try {
            var /** @type {?} */ url = new URL("https://dummy.de" + state.url);
            authData = {
                accessToken: url.searchParams.get('token') || url.searchParams.get('auth_token'),
                client: url.searchParams.get('client_id'),
                expiry: url.searchParams.get('expiry'),
                tokenType: 'Bearer',
                uid: url.searchParams.get('uid')
            };
        }
        catch (/** @type {?} */ error) {
            authData = {
                accessToken: this.getUrlParameter(state.url, 'token') || this.getUrlParameter(state.url, 'auth_token'),
                client: this.getUrlParameter(state.url, 'client_id'),
                expiry: this.getUrlParameter(state.url, 'expiry'),
                tokenType: 'Bearer',
                uid: this.getUrlParameter(state.url, 'uid')
            };
        }
        if (this.checkAuthData(authData)) {
            this.atCurrentAuthData = authData;
            this.setAuthData(this.atCurrentAuthData);
            this.validateToken().subscribe(function (res) { return _this.atAsyncStatus.next(true); }, function (error) {
                _this.cleanStorage();
                _this.atAsyncStatus.next(false);
            });
            return this.atAsyncStatus;
        }
        else {
            this.atAsyncStatus.next(false);
            return this.atAsyncStatus;
        }
    };
    /**
     * @return {?}
     */
    AuthService.prototype.canActivate = /**
     * @return {?}
     */
    function () {
        if (this.userSignedIn()) {
            return true;
        }
        else {
            // Store current location in storage (usefull for redirection after signing in)
            if (this.atOptions.signInStoredUrlStorageKey) {
                localStorage.setItem(this.atOptions.signInStoredUrlStorageKey, window.location.pathname + window.location.search);
            }
            // Redirect user to sign in if signInRedirect is set
            if (this.router && this.atOptions.signInRedirect) {
                this.router.navigate([this.atOptions.signInRedirect]);
            }
            return false;
        }
    };
    // Inital configuration
    /**
     * @param {?=} options
     * @return {?}
     */
    AuthService.prototype.init = /**
     * @param {?=} options
     * @return {?}
     */
    function (options) {
        var /** @type {?} */ defaultOptions = {
            apiPath: null,
            apiBase: null,
            websiteHost: "https://" + window.location.host,
            signInPath: 'auth/sign_in',
            signInRedirect: null,
            signInStoredUrlStorageKey: null,
            signOutPath: 'auth/sign_out',
            validateTokenPath: 'auth/validate_token',
            // TODO set default back to false after config init exists
            signOutFailedValidate: true,
            registerAccountPath: 'auth',
            deleteAccountPath: 'auth',
            registerAccountCallback: undefined,
            updatePasswordPath: 'auth',
            resetPasswordPath: 'auth/password',
            resetPasswordCallback: undefined,
            userTypes: null,
        };
        this.atOptions = (/** @type {?} */ (Object)).assign(defaultOptions, options);
        this.tryLoadAuthData();
    };
    /**
     *
     * Actions
     *
     */
    // Register request
    /**
     *
     * Actions
     *
     * @param {?} registerData
     * @return {?}
     */
    AuthService.prototype.registerAccount = /**
     *
     * Actions
     *
     * @param {?} registerData
     * @return {?}
     */
    function (registerData) {
        var _this = this;
        if (registerData.userType == null) {
            this.atCurrentUserType = null;
        }
        else {
            this.atCurrentUserType = this.getUserTypeByName(registerData.userType);
            delete registerData.userType;
        }
        registerData["password_confirmation"] = registerData.passwordConfirmation;
        delete registerData.passwordConfirmation;
        var /** @type {?} */ redirect_url = this.getRedirectUrl();
        if (redirect_url) {
            redirect_url = redirect_url.includes('http') ? redirect_url : "" + this.atOptions.websiteHost + redirect_url;
        }
        registerData["confirm_success_url"] = redirect_url ? redirect_url : this.atOptions.registerAccountCallback;
        var /** @type {?} */ observ = this.http.post(this.getApiPath() + this.getUserPath() + this.atOptions.registerAccountPath, registerData, {
            observe: 'response'
        }).share();
        observ.subscribe(function (res) {
            _this.getAuthHeadersFromResponse(res);
            _this.atCurrentUserData = res['body']['data'];
        }, function (_error) { return null; });
        return observ;
    };
    // Sign in request and set storage
    /**
     * @param {?} signInData
     * @return {?}
     */
    AuthService.prototype.signIn = /**
     * @param {?} signInData
     * @return {?}
     */
    function (signInData) {
        var _this = this;
        if (signInData.userType == null) {
            this.atCurrentUserType = null;
        }
        else {
            this.atCurrentUserType = this.getUserTypeByName(signInData.userType);
        }
        var /** @type {?} */ body = {
            email: signInData.email,
            password: signInData.password
        };
        var /** @type {?} */ observ = this.http.post(this.getApiPath() + this.getUserPath() + this.atOptions.signInPath, body, { observe: 'response' }).share();
        observ.subscribe(function (res) {
            _this.getAuthHeadersFromResponse(res);
            _this.atCurrentUserData = res['body']['data'];
        }, function (_error) { return null; });
        return observ;
    };
    // Sign out request and delete storage
    /**
     * @return {?}
     */
    AuthService.prototype.signOut = /**
     * @return {?}
     */
    function () {
        var _this = this;
        var /** @type {?} */ observ = this.http.delete(this.getApiPath() + this.getUserPath() + this.atOptions.signOutPath, {
            withCredentials: true,
            observe: 'response'
        }).do(function (res) {
            _this.cleanStorage();
        }, function (error) {
            if (error.status === 404 && _this.atOptions.signOutFailedValidate) {
                _this.cleanStorage();
            }
        }).share();
        return observ;
    };
    /**
     * @return {?}
     */
    AuthService.prototype.cleanStorage = /**
     * @return {?}
     */
    function () {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('client');
        localStorage.removeItem('expiry');
        localStorage.removeItem('tokenType');
        localStorage.removeItem('uid');
        this.atCurrentAuthData = null;
        this.atCurrentUserType = null;
        this.atCurrentUserData = null;
    };
    // Validate token request
    /**
     * @return {?}
     */
    AuthService.prototype.validateToken = /**
     * @return {?}
     */
    function () {
        var _this = this;
        var /** @type {?} */ observ = this.http.get(this.getApiPath() + this.getUserPath() + this.atOptions.validateTokenPath, { withCredentials: true }).share();
        observ.subscribe(function (res) { return _this.atCurrentUserData = res['data']; }, function (error) {
            if (error.status === 404 && _this.atOptions.signOutFailedValidate) {
                _this.signOut();
            }
        });
        return observ;
    };
    // Update password request
    /**
     * @param {?} updatePasswordData
     * @return {?}
     */
    AuthService.prototype.updatePassword = /**
     * @param {?} updatePasswordData
     * @return {?}
     */
    function (updatePasswordData) {
        if (updatePasswordData.userType != null) {
            this.atCurrentUserType = this.getUserTypeByName(updatePasswordData.userType);
        }
        var /** @type {?} */ args;
        if (updatePasswordData.passwordCurrent == null) {
            args = {
                password: updatePasswordData.password,
                password_confirmation: updatePasswordData.passwordConfirmation
            };
        }
        else {
            args = {
                current_password: updatePasswordData.passwordCurrent,
                password: updatePasswordData.password,
                password_confirmation: updatePasswordData.passwordConfirmation
            };
        }
        if (updatePasswordData.resetPasswordToken) {
            args.reset_password_token = updatePasswordData.resetPasswordToken;
        }
        return this.http.put(this.getApiPath() + this.getUserPath() + this.atOptions.updatePasswordPath, args, { withCredentials: true }).share();
    };
    // Reset password request
    /**
     * @param {?} resetPasswordData
     * @return {?}
     */
    AuthService.prototype.resetPassword = /**
     * @param {?} resetPasswordData
     * @return {?}
     */
    function (resetPasswordData) {
        if (resetPasswordData.userType == null) {
            this.atCurrentUserType = null;
        }
        else {
            this.atCurrentUserType = this.getUserTypeByName(resetPasswordData.userType);
        }
        var /** @type {?} */ redirect_url = this.getRedirectUrl();
        if (redirect_url) {
            var /** @type {?} */ url = redirect_url.includes('http') ? new URL(redirect_url) : new URL(this.atOptions.resetPasswordCallback);
            url.searchParams.append('go_redirect_url', redirect_url);
            redirect_url = url.toString();
        }
        var /** @type {?} */ body = {
            email: resetPasswordData.email,
            redirect_url: redirect_url ? redirect_url : this.atOptions.resetPasswordCallback
        };
        return this.http.post(this.getApiPath() + this.getUserPath() + this.atOptions.resetPasswordPath, body).share();
    };
    /**
     *
     * Get Auth Data
     *
     * @return {?}
     */
    AuthService.prototype.getRedirectUrl = /**
     *
     * Get Auth Data
     *
     * @return {?}
     */
    function () {
        var /** @type {?} */ redirect_url = localStorage.getItem('go-redirect-url');
        localStorage.removeItem('go-redirect-url');
        return redirect_url;
    };
    /**
     * @return {?}
     */
    AuthService.prototype.tryLoadAuthData = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ userType = this.getUserTypeByName(localStorage.getItem('userType'));
        if (userType) {
            this.atCurrentUserType = userType;
        }
        this.getAuthDataFromStorage();
        if (this.activatedRoute) {
            this.getAuthDataFromParams();
        }
        if (this.atCurrentAuthData) {
            this.validateToken();
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    AuthService.prototype.getAuthHeadersFromResponse = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var /** @type {?} */ headers = data.headers;
        var /** @type {?} */ authData = {
            accessToken: headers.get('access-token'),
            client: headers.get('client'),
            expiry: headers.get('expiry'),
            tokenType: headers.get('token-type'),
            uid: headers.get('uid')
        };
        this.setAuthData(authData);
    };
    /**
     * @return {?}
     */
    AuthService.prototype.getAuthDataFromParams = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.activatedRoute.queryParams) {
            // Fix for Testing, needs to be removed later
            this.activatedRoute.queryParams.subscribe(function (queryParams) {
                var /** @type {?} */ authData = {
                    accessToken: queryParams['token'] || queryParams['auth_token'],
                    client: queryParams['client_id'],
                    expiry: queryParams['expiry'],
                    tokenType: 'Bearer',
                    uid: queryParams['uid']
                };
                if (_this.checkAuthData(authData)) {
                    _this.atCurrentAuthData = authData;
                    _this.setAuthData(_this.atCurrentAuthData);
                    _this.validateToken().subscribe(function () { }, function () { return _this.cleanStorage(); });
                }
            });
        }
    };
    /**
     *
     * Set Auth Data
     *
     * @param {?} authData
     * @return {?}
     */
    AuthService.prototype.setAuthData = /**
     *
     * Set Auth Data
     *
     * @param {?} authData
     * @return {?}
     */
    function (authData) {
        if (this.checkAuthData(authData)) {
            this.atCurrentAuthData = authData;
            localStorage.setItem('accessToken', authData.accessToken);
            localStorage.setItem('client', authData.client);
            localStorage.setItem('expiry', authData.expiry);
            localStorage.setItem('tokenType', authData.tokenType);
            localStorage.setItem('uid', authData.uid);
            if (this.atCurrentUserType != null) {
                localStorage.setItem('userType', this.atCurrentUserType.name);
            }
        }
    };
    /**
     *
     * Construct Paths / Urls
     *
     * @return {?}
     */
    AuthService.prototype.getUserPath = /**
     *
     * Construct Paths / Urls
     *
     * @return {?}
     */
    function () {
        if (this.atCurrentUserType == null) {
            return '';
        }
        else {
            return this.atCurrentUserType.path + '/';
        }
    };
    /**
     * @return {?}
     */
    AuthService.prototype.getApiPath = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ constructedPath = '';
        if (this.atOptions.apiBase != null) {
            constructedPath += this.atOptions.apiBase + '/';
        }
        if (this.atOptions.apiPath != null) {
            constructedPath += this.atOptions.apiPath + '/';
        }
        return constructedPath;
    };
    /**
     *
     * Utilities
     *
     * @param {?} name
     * @return {?}
     */
    AuthService.prototype.getUserTypeByName = /**
     *
     * Utilities
     *
     * @param {?} name
     * @return {?}
     */
    function (name) {
        if (name == null || this.atOptions.userTypes == null) {
            return null;
        }
        return this.atOptions.userTypes.find(function (userType) { return userType.name === name; });
    };
    AuthService.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    AuthService.ctorParameters = function () { return [
        { type: http.HttpClient, },
        { type: router.ActivatedRoute, decorators: [{ type: core.Optional },] },
        { type: router.Router, decorators: [{ type: core.Optional },] },
    ]; };
    return AuthService;
}(AuthUtilsService));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AuthGuard = (function () {
    function AuthGuard(auth, router$$1) {
        this.auth = auth;
        this.router = router$$1;
    }
    /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    AuthGuard.prototype.canActivate = /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    function (next, state) {
        var _this = this;
        if (this.auth.userSignedIn()) {
            return this.handleRedirect();
        }
        else if (this.auth.hasAuthParams(state.url)) {
            return this.auth.canActivateAsync(state).map(function (res) {
                return res ? _this.handleRedirect() : false;
            }, function (error) {
                return _this.userNotPresent(state.url);
            });
        }
        else {
            return this.userNotPresent(state.url);
        }
    };
    /**
     * @param {?} route
     * @return {?}
     */
    AuthGuard.prototype.canLoad = /**
     * @param {?} route
     * @return {?}
     */
    function (route) {
        // TODO implement canLoad guard
        return true;
    };
    /**
     * @return {?}
     */
    AuthGuard.prototype.handleRedirect = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ url = localStorage.getItem('go-redirect-url');
        localStorage.removeItem('go-redirect-url');
        if (url) {
            this.router.navigateByUrl(url);
            return false;
        }
        else {
            return true;
        }
    };
    /**
     * @param {?} url
     * @return {?}
     */
    AuthGuard.prototype.userNotPresent = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return false;
    };
    AuthGuard.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    AuthGuard.ctorParameters = function () { return [
        { type: AuthService, },
        { type: router.Router, },
    ]; };
    return AuthGuard;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AuthHttpInterceptor = (function () {
    function AuthHttpInterceptor(auth) {
        this.auth = auth;
    }
    // Construct and send Http request
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    AuthHttpInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        if (!req.withCredentials) {
            return next.handle(req);
        }
        // Get auth data from local storage
        var /** @type {?} */ currentAuthData = this.auth.getAuthDataFromStorage();
        // Merge auth headers to request if set
        if (currentAuthData && currentAuthData.accessToken != null) {
            var /** @type {?} */ authReq = req.clone({
                headers: req.headers
                    .set('access-token', currentAuthData.accessToken)
                    .set('client', currentAuthData.client)
                    .set('expiry', currentAuthData.expiry)
                    .set('token-type', currentAuthData.tokenType)
                    .set('uid', currentAuthData.uid)
            });
            return next.handle(authReq);
        }
        else {
            return next.handle(req);
        }
    };
    AuthHttpInterceptor.decorators = [
        { type: core.Injectable },
    ];
    /** @nocollapse */
    AuthHttpInterceptor.ctorParameters = function () { return [
        { type: AuthUtilsService, },
    ]; };
    return AuthHttpInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// import './auth.model';
var AuthModule = (function () {
    function AuthModule() {
    }
    AuthModule.decorators = [
        { type: core.NgModule, args: [{
                    providers: [
                        AuthUtilsService,
                        AuthService,
                        AuthGuard,
                        AuthHttpInterceptor,
                        {
                            provide: http.HTTP_INTERCEPTORS,
                            useClass: AuthHttpInterceptor,
                            multi: true,
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    AuthModule.ctorParameters = function () { return []; };
    return AuthModule;
}());

exports.AuthModule = AuthModule;
exports.AuthUtilsService = AuthUtilsService;
exports.AuthGuard = AuthGuard;
exports.AuthHttpInterceptor = AuthHttpInterceptor;
exports.AuthService = AuthService;

Object.defineProperty(exports, '__esModule', { value: true });

})));
